<p class="agreements">
  <small class="extra">
    By clicking Sign up/Log in or Sign up/Log in with LinkedIn, GitHub, or
    Google, you agree to Job Ring’s <a routerLink="/terms">Terms of Use</a> and
    <a routerLink="/privacy-policy">Privacy Policy</a>. Job Ring may send you
    communications.
  </small>
</p>
